import { render, staticRenderFns } from "./alarmTimeBox.vue?vue&type=template&id=b2e3d332&scoped=true"
import script from "./alarmTimeBox.vue?vue&type=script&lang=js"
export * from "./alarmTimeBox.vue?vue&type=script&lang=js"
import style0 from "./alarmTimeBox.vue?vue&type=style&index=0&id=b2e3d332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e3d332",
  null
  
)

export default component.exports